<template>
    <form id="onboarding-de" class="wrapper" role="form" method="post">
        <template v-if="showDisclaimer">
            <div class="text-wrapper text-centered">
                <span class="new-headline-xlg">Siamo spiacenti.<br>Vitadio è indicato solo per i pazienti con diabete di tipo 2.</span>
                <p class="new-text-lg text-color-default">La risposta "No, non ho il diabete di tipo 2" indica che al momento non puoi iscriverti al programma.</p>
                <v-button href="/" label="Torna alla pagina iniziale" position="center"></v-button>
            </div>
        </template>
        <template v-else>
            <header>
                <span class="new-headline-xlg text-centered">Hai il diabete di tipo 2?</span>
            </header>

            <div class="form-input-radio-button-wrapper-two-columns">
                <div 
                    class="form-input-radio-button-big"
                    id="yes"
                    @click="chooseOption('Yes')"
                    >
                    <div class="form-input-radio-button-inner">
                        <figure class="form-input-radio-button-icon">
                            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M33.2261 65.2487C50.8992 65.2487 65.2261 50.9217 65.2261 33.2484C65.2261 15.5751 50.8992 1.24805 33.2261 1.24805C15.553 1.24805 1.22607 15.5751 1.22607 33.2484C1.22607 50.9217 15.553 65.2487 33.2261 65.2487Z" fill="#54DBA3"/>
                            <path d="M27.4 40.4L45.55 22.25C45.85 21.95 46.2 21.8 46.6 21.8C47.0333 21.8 47.4 21.95 47.7 22.25C48 22.55 48.15 22.9167 48.15 23.35C48.15 23.75 48 24.1 47.7 24.4L28.45 43.65C28.15 43.95 27.8 44.1 27.4 44.1C27 44.1 26.65 43.95 26.35 43.65L17.25 34.55C16.95 34.25 16.8 33.9 16.8 33.5C16.8333 33.0667 17 32.7 17.3 32.4C17.6 32.1 17.95 31.95 18.35 31.95C18.7833 31.95 19.15 32.1 19.45 32.4L27.4 40.4Z" fill="white"/>
                            </svg>
                        </figure> 
                        <span class="label-static">Sì</span>
                    </div>
                </div>
                
                <div 
                    class="form-input-radio-button-big form-input-radio-button--danger"
                    id="no"
                    @click="chooseOption('No')"
                    >
                    <div class="form-input-radio-button-inner">
                        <figure class="form-input-radio-button-icon">
                            <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z" fill="#FF3E57"/>
                            <path d="M32.5625 34.1L22.0625 44.6C21.7625 44.9 21.4125 45.05 21.0125 45.05C20.6125 45.05 20.2625 44.9 19.9625 44.6C19.6625 44.3 19.5125 43.95 19.5125 43.55C19.5125 43.15 19.6625 42.8 19.9625 42.5L30.4625 32L19.9625 21.5C19.6625 21.2 19.5125 20.85 19.5125 20.45C19.5125 20.05 19.6625 19.7 19.9625 19.4C20.2625 19.1 20.6125 18.95 21.0125 18.95C21.4125 18.95 21.7625 19.1 22.0625 19.4L32.5625 29.9L43.0625 19.4C43.3625 19.1 43.7125 18.95 44.1125 18.95C44.5125 18.95 44.8625 19.1 45.1625 19.4C45.4625 19.7 45.6125 20.05 45.6125 20.45C45.6125 20.85 45.4625 21.2 45.1625 21.5L34.6625 32L45.1625 42.5C45.4625 42.8 45.6125 43.15 45.6125 43.55C45.6125 43.95 45.4625 44.3 45.1625 44.6C44.8625 44.9 44.5125 45.05 44.1125 45.05C43.7125 45.05 43.3625 44.9 43.0625 44.6L32.5625 34.1Z" fill="white"/>
                            </svg>
                        </figure> 
                        <span class="label-static">No</span>
                    </div>
                </div>
            </div>
        </template>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                checkedYes: false,
                checkedNo: false, 
                showDisclaimer: false
            }
        },

        methods: {
            chooseOption(selection) {
                if (selection === 'Yes') {
                    this.checkedYes = true
                    this.checkedNo = false
                    this.showDisclaimer = false

                    window.dataLayer.push({
                        'event': 'pre_registration_web',
                        'conversion': 'Type 2 confirmation'
                    })

                    this.onClickButton()
                }

                if (selection === 'No') {
                    this.checkedNo = true
                    this.checkedYes = false

                    setTimeout(() => {
                        this.showDisclaimer = true
                        document.querySelector('.progress-bar').style.display = 'none'
                        document.querySelector('.progress-num').style.display = 'none'
                    }, 250);
                }
            },

            onClickButton () {
                setTimeout(() => {
                    this.$emit('clicked', null)
                }, 250);
            },
        }
    }
</script>